export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      bot: {
        botId: 1,
        botUuid: "bots001",
        botName: "アイラ地域サポート向け見守りbot",
          botUrl: "https://xxxxx.xx.xx",
        botEmail: "mail@xxxxx.com",
        botPassword: "passxxxxx",
        // botNotifyTo: ["aaaaaa@cccc.com"],
        service: {
          serviceUuid: "services001",
          serviceName: "アイラ地域サポート"
        }
      }
    }
  }
}